import { createFileRoute } from '@tanstack/react-router'
import { SignalsPage, validateSignalsSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. `?wbId=` narrows to one detection's signals;
 * `?signal=` (legacy alias `?sig_id=`) opens the signal in the pane;
 * `?queue=all` picks the queue tab (absent = Unassigned).
 */
function SignalsRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <SignalsPage clusterId={clusterId} scopeId={scopeId} search={search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/signals')({
  validateSearch: validateSignalsSearch,
  component: SignalsRoute,
})
